import { render, staticRenderFns } from "./AdminInvoiceItemTableRow.vue?vue&type=template&id=c70b3170&"
import script from "./AdminInvoiceItemTableRow.vue?vue&type=script&lang=ts&"
export * from "./AdminInvoiceItemTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports